var exports = {
  "n": "panel__wjmbOQ",
};

module.exports = exports;
